export class Utility {
    public static ConvertToType<T> (item :any) :T | null{
        return item === null ? null : item as T;
    }
}